// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Nr4r","option":"styles_option__KPGub","selected":"styles_selected__19LXO"};